import React from "react";
import styles from "./aboutHerosection.module.css";
import heroImage from "../../assets/images/aboutUs/personAbout.png";
import heroImageResponsive from "../../assets/images/aboutUs/personAboutResponsive.png";
import LazyLoad from "react-lazyload";

const HeroSection = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.text}>
          <h1>About Us</h1>
          <p>
            Cairo Capital is a premier financial institution with a legacy of
            over two decades, dedicated to delivering comprehensive financial
            solutions across Egypt and the MENA region. Established in 1995 as
            an asset management firm, it has since evolved into a diversified
            powerhouse, offering securities brokerage, asset management, private
            equity, and startup ventures. Guided by a commitment to excellence,
            innovation, and transparency, Cairo Capital operates under the
            authorization of the Financial Regulatory Authority (FRA),
            solidifying its position as a trusted partner in the financial
            landscape.
          </p>
          <p>
            Cairo Capital is committed to leveraging its extensive market
            insights and robust financial resources to invest across a spectrum
            of sectors, including financial services, agriculture, healthcare,
            education, and startup technology companies. We will achieve this
            through our own subsidiaries and affiliates whether wholly owned or
            majority owned, or through different investment structures
            particularly Fund Management Structures, where Cairo Capital acts as
            the General Partner (GP). Our mission is to deliver above-market
            returns to our shareholders while fostering long-term economic
            stability and growth through strategic partnerships and investments
            in both established and emerging markets. By embracing fit-for-
            purpose technology solutions—including software development and
            where relevant robotics—we enhance operational efficiency and
            effectiveness of the underlying investments, amplifying the value of
            our investments and ensuring our portfolio remains versatile,
            forward-looking, and poised to capitalize on current and future
            opportunities.
          </p>
        </div>
        <div className={styles.image}>
          <LazyLoad offset={100} once>
            <img
              src={heroImage}
              alt="CFH representative"
              className={styles.representativeImage}
            />
          </LazyLoad>
          <img
            src={heroImageResponsive}
            alt="CFH representative"
            className={styles.representativeResponsiveImage}
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
